import { FlightCategory } from './flight.constant';

export enum RequestStatus {
  InFlight = 'In Flight',
  Declined = 'Declined',
  PendingApproval = 'Pending Approval',
  Approved = 'Approved',
  RequiresFlightCost = 'Requires Flight Cost',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Received = 'Request Received',
}
export const MonthViewEvents = {
  PatrolPassenger: 'Patrol Passenger',
  Construction: 'Construction',
  InternalDrone: 'Internal Drone',
  ExternalDrone: 'External Drone',
  ExternalManned: 'External Manned',
  PendingApproval: 'Pending Approval',
  Received: 'Request Received'
} as const;

export enum NotificationRequestStatus {
  PendingApproval = 'Pending Approval',
  Cancelled = 'Cancelled',
}

export const RequestFlightPathName = {
  [FlightCategory.PatrolPassenger]: 'patrolPassenger',
  [FlightCategory.ContractorPatrol]: 'patrolPassengerContractor',
  [FlightCategory.ConstructionWork]: 'construction',
  [FlightCategory.ContractorConstruction]: 'constructionContractor',
  [FlightCategory.DroneFlightInternal]: 'droneInternal',
  [FlightCategory.DroneFlightExternal]: 'droneExternal',
} as const;

export enum RequestListTab {
  All,
  Passenger,
  Construction,
  Helicopter,
  Drone,
}

export enum PassengerType {
  Employee = 'Employee',
  Contractor = 'Contractor',
}

export enum HecType {
  Ground = 'Ground to Ground',
  Structure = 'Ground to Structure',
  Midspan = 'Midspan',
}

export enum EXUType {
  EXU = 'EXU',
  CWN = 'CWN',
}

export enum TARStatus {
  Approved = 1,
  Submitted = 2,
  Denied = 3,
}

export const DEFAULT_EMPLOYEE_NUMBER = '0';
